export default __webpack_public_path__ + "static/media/ddos.3c125cd5.svg";